import utils from "@/libs/utils";
import { getCookie } from "./env";

/* 
起点根据ua的 QDNightStyle_2
Q阅根据cookie 的 nightMode = 1
*/
const APP_NAMES = {
  QDReader: "QDReader",
  QQReader: "QQReader",
  H5: "H5",
} as const;

function detectAppName(): (typeof APP_NAMES)[keyof typeof APP_NAMES] {
  if (utils.isQD()) return APP_NAMES.QDReader;
  if (utils.isQQReader()) return APP_NAMES.QQReader;
  return APP_NAMES.H5;
}

function isQDDarkMode(): boolean {
  const qdBg = new URLSearchParams(window.location.search).get("_qdbg") || "0";
  if (qdBg && qdBg !== "0") return qdBg === "2";
  return navigator.userAgent.includes("QDNightStyle_2");
}

function isQQReaderDarkMode(): boolean {
  const _nightMode = getCookie("nightMode");
  return _nightMode === "1";
}

const app = detectAppName();
export const isDarkMode = (): boolean => {
  let isDark = false;
  if (app === APP_NAMES.QDReader) isDark = isQDDarkMode();
  else if (app === APP_NAMES.QQReader) isDark = isQQReaderDarkMode();
  return isDark;
};

export const setTheme = (): void => {
  const isDark: boolean = isDarkMode();
  if (isDark) {
    const darkClass = `dark-mode_${app}`;
    document.documentElement.classList.toggle(darkClass, isDark);
    const appEl = document.getElementById("body");
    if (appEl) {
      appEl.classList.toggle(darkClass, isDark);
    }
  }
};

export default {
  isDarkMode,
  setTheme,
};
